export const parseArray = (sArr: string) =>
  sArr.replace(' ', '').replace('[', '').replace(']', '').split(',');
